module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"qr_code_section_title":"Subscription QR code"},"es":{"qr_code_section_title":"Código QR de subscripción"}}')
  delete Component.options._Ctor
}
